<template>
  <section class="pt-3 mx-8 mt-5 relative">
    <div class="flex items-center">
      <div>
        <h3 class="text-3xl text-[#101828] font-medium">
          {{ $t("homeview.welcome") }},
          <span class="normal-case">{{ isUsername?.first_name }}</span>
        </h3>
        <p class="text-base text-gray-500 font-normal">
          {{ $t("homeview.manageProjects") }}
        </p>
      </div>

    </div>
    <PmLocals class="mt-8" />
  </section>
</template>

<script lang="js">
import { defineComponent } from "vue";

import { getTransString } from "@/services/helpers";
import Api from "@/services/api";

import PmLocals from "../pm-locals/PmLocals.vue";
import TodosCard from "@/components/dashboard/home/TodosCard.vue";
export default defineComponent({
  name: "HomeView",
  components: {
    PmLocals,
  },
  data() {
    return {
      data: [],
      projectId: this.$route.query.id,
      currentPages: 1,
      showTodos: false
    };
  },

  computed: {

    isUsername() {
      return this.$store.getters["auth/isUserDetails"];
    },

    currentPage() {
      return this.$store.getters["hrResources/isCurrentPage"];
    },
    // for notification
  },
  methods: {
    getTranslatedStringKey(field) {
      return getTransString(field);
    },

handleTodos(){
  this.showTodos = !this.showTodos;
},

handleAlertAndRefetch({ type, title, state }) {
  this.alertType = type;
  this.alertTitle = title;
  this.alertState = state;

  this.getUserHomePage();
},

    getUserHomePage() {
      Api()
        .get(`/auth/get-user-information/`)
        .then(response => {
          if (response.data.status === "success") {
            this.data = response.data.data;
            this.$store.commit("auth/SET_AUTH_USER_INFO", this.data);

          }
        })
    },



    async getUserInfo() {
      const userInfoResp = await Api().get("/auth/get-user-information/");
      this.$store.commit("auth/SET_AUTH_USER_INFO", userInfoResp?.data?.data);
    }

  },
  mounted() {
    this.getUserHomePage()

    this.$store.commit("hrResources/SET_HOME_TO_STATE", false);
    this.$store.commit("auth/SET_RAIL_TO_STATE", false);

  },

});
</script>
